import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NetworkService } from '../../shared/network.service';
@Injectable({
  providedIn: 'root'
})
export class SettingService {
  private pageChange = new BehaviorSubject('false');
  currentPage = this.pageChange.asObservable();

  constructor(private networkService: NetworkService,
    ) { }

  createAdmin(body:any) {
    return this.networkService.post("api/users/admin",body, null,'bearer');
  }
  updateUser(body:any) {
    return this.networkService.put("api/users",body, null,'bearer');
  }
  getMemberList(query:any) {
    return this.networkService.get("api/users/userList?"+query,null, null,'bearer');
  }
  getdiscussion(query:any) {
    return this.networkService.get("api/resourceAndDiscussions/discussion?"+query,null, null,'bearer');
  }
  deletediscussion(query:any) {
    return this.networkService.delete("api/resourceAndDiscussions/discussion/"+query,null, null,'bearer');
  }
  getResource(query:any) {
    return this.networkService.get("api/resourceAndDiscussions/resource?"+query,null, null,'bearer');
  }
  getCircleList(query:any) {
    return this.networkService.get("api/circles/circleList?isAdmin=true&"+query,null, null,'bearer');
  }
  getFormCircleList(query:any) {
    return this.networkService.get("api/circles/circleList?"+query,null, null,'bearer');
  }
  
  getUsersFormList(query:any) {
    return this.networkService.get("api/forms/responded/users?"+query,null, null,'bearer');
  }

  getUserRespondedFormsList(query:any) {
    return this.networkService.get("api/forms/responses"+query,null, null,'bearer');
  }

  editCircleListInForm(body:any) {
    return this.networkService.put("api/circles/circleList?",body, null,'bearer');
  }

  getEventList(query:any) {
    return this.networkService.get("api/events?isAdmin=true&"+query,null, null,'bearer');
  }

  getAttachmentList(query:any) {
    return this.networkService.get("api/circleAttachments?isAdmin=true&"+query,null, null,'bearer');
  }


 
  updateResource(query:any) {
    return this.networkService.put("api/resourceAndDiscussions/resource"+query,null, null,'bearer');
  }
  createResource(query:any) {
    return this.networkService.post("api/resourceAndDiscussions/resource",query, null,'bearer');
  }
  sendEmailInvite(query:any) {
    return this.networkService.post("api/forms/invite",query, null,'bearer');
  }
  getInvitedUser(query:any) {
    return this.networkService.get("api/forms/invited/users?"+query,null, null,'bearer');
  }
  
  uploadPdf(image: any) {
    const formData = new FormData();
    formData.append("file",image);
    return this.networkService.uploadImages("api/s3upload/media-upload", formData, null, "bearer");
  }

  
  
  categoryListDropdown(query:any) {
    return this.networkService.get("api/resourceAndDiscussions/resourceCategory?isAdmin=true"+query,null, null,'bearer');
  }
  attachmentCateory(query) {
    return this.networkService.get("api/dropdowns/circleCategories",null, null,'bearer');
  }
  addCategory(query:any) {
    return this.networkService.post("api/dropdowns/circleCategories",query, null,'bearer');
  }
  addReseach(query:any) {
    return this.networkService.post("api/dropdowns/researchFocus",query, null,'bearer');
  }
  updateCategory(query:any) {
    return this.networkService.put("api/dropdowns/circleCategories",query, null,'bearer');
  }
  deleteCategory(query:any) {
    return this.networkService.delete("api/dropdowns/circleCategories/"+query+"?isAdmin=true",null, null,'bearer');
  }
  deleteResearchApi(query:any) {
    return this.networkService.delete("api/dropdowns/researchFocus/"+query,null, null,'bearer');
  }
  deleteCirle(query:any) {
    return this.networkService.delete("api/circles/"+query+"?isAdmin=true",null, null,'bearer');
  }
  deleteResource(query:any) {
    
    return this.networkService.delete("api/resourceAndDiscussions/resource/"+query+"?isAdmin=true",null, null,'bearer');
  }
  verifyEmail(body:any) {
    return this.networkService.post("api/users/verifyEmail",body, null,'bearer');
  }
  deleteCircleAttachment(query:any) {
    return this.networkService.delete("api/circleAttachments/"+query+"?isAdmin=true",null, null,'bearer');
  }
  deleteEvent(query:any) {
    return this.networkService.delete("api/events/"+query+"?isAdmin=true",null, null,'bearer');
  }
  deleteCircle(query:any) {
    return this.networkService.delete("api/circles/"+query+"?isAdmin=true",null, null,'bearer');
  }

  getCircleType() {
    return this.networkService.get("api/dropdowns/circleTypes?showHidden=true",null, null,'bearer');
  }
  getCircleTypeFalse() {
    return this.networkService.get("api/dropdowns/circleTypes?showHidden=false",null, null,'bearer');
  }
  AddCircleType(body:any) {
    return this.networkService.post("api/dropdowns/circleTypes",body, null,'bearer');
  }
  updateCircleType(body:any) {
    return this.networkService.put("api/dropdowns/circleTypes",body, null,'bearer');
  }

  getEventType() {
    return this.networkService.get("api/dropdowns/eventTypes?showHidden=true",null, null,'bearer');
  }
  updateEventType(body:any) {
    return this.networkService.put("api/dropdowns/eventTypes",body, null,'bearer');
  }
  AddEventType(body:any) {
    return this.networkService.post("api/dropdowns/eventTypes",body, null,'bearer');
  }
  getUserRoleType() {
    return this.networkService.get("api/dropdowns/userRoles?showHidden=true",null, null,'bearer');
  }
  updateUserRole(body:any) {
    return this.networkService.put("api/dropdowns/userRoles",body, null,'bearer');
  }
  CreateUserRole(body:any) {
    return this.networkService.post("api/dropdowns/userRoles",body, null,'bearer');
  }

  uploadImage(image: any) {
    const formData = new FormData();
    formData.append("file",image);
    return this.networkService.uploadImages("api/s3upload/media-upload", formData, null, "bearer");
  }

  //  Poll apis
  getPollList(query) {
    return this.networkService.get("api/polls?"+ query,null, null,'bearer');
  }
  
  MarkCompletePoll(body:any) {
    return this.networkService.put("api/polls",body, null,'bearer');
  }
  getDashboardCountApi() {
    return this.networkService.get("api/dashboard/users/count",null, null,'bearer');
  }
  getDicussion(query) {
    return this.networkService.get("api/resourceAndDiscussions/discussion?"+query,null, null,'bearer');
  }
  getUserAnalyticApi(query) {
    return this.networkService.get("api/dashboard/users/list?"+query,null, null,'bearer');
  }

  getNewUserBarGraphApi(query) {
    return this.networkService.get("api/dashboard/newUsersMonthlyData?"+query,null, null,'bearer');
  }
  getActiveUsersBarGraphApi(query) {
    return this.networkService.get("api/dashboard/activeUsersMonthlyData?"+query,null, null,'bearer');
  }
  
  getUserOrActivityListApi(query) {
    return this.networkService.get("api/dashboard/users/list?"+query,null, null,'bearer');
  }
  // will use later
  // getUserOrActivityCircleListApi(query) {
  //   console.log('errorr6');
  //   return this.networkService.get("api/users/userList?hideSelf=true?"+query,null, null,'bearer');
  // }

  // lite 
  getUserOrActivityCircleListApi(query) {
    console.log('errorr6');
    return this.networkService.get("api/users/list/lite?hideSelf=true?"+query,null, null,'bearer');
  }
  getActiveUserListApi(query) {
    return this.networkService.get("api/dashboard/active/users/list?"+query,null, null,'bearer');
  }

  getActiveUserFormsListApi(query) {
    return this.networkService.get("api/users/userList?"+query,null, null,'bearer');
  }
 
  getConnectionListApi(query) {
    return this.networkService.get("api/dashboard/connections?"+query,null, null,'bearer');
  }
  getCirclesListApi(query) {
    return this.networkService.get("api/dashboard/circles/list?"+query,null, null,'bearer');
  }

  // CIRCLE ACT
  

 getCirclesLatestActivityListApi(query) {
    return this.networkService.get("api/dashboard/circles/list?"+query,null, null,'bearer');
  }
  
  getCircleMemberListApi(query) {
    return this.networkService.get("api/circles/members?"+query,null, null,'bearer');
  }
  getCircleAttachmentsListApi(query) {
    return this.networkService.get("api/circleAttachments?"+query,null, null,'bearer');
  }

  getNewCircleBarGraphApi(query) {
    return this.networkService.get("api/dashboard/circlesMonthlyData?"+query,null, null,'bearer');
  }
  getImpactTypeApi(query) {
    return this.networkService.get("api/impacts/impactTypes?"+query,null, null,'bearer');
  }
  getSourceTypeApi(query) {
    return this.networkService.get("api/impacts/impactSources?"+query,null, null,'bearer');
  }
  getImpactListApi(query) {
    return this.networkService.get("api/impacts?"+query,null, null,'bearer');
  }
  getImpactReason(query) {
    return this.networkService.get("api/impacts/inclusionReasons?"+query,null, null,'bearer');
  }
  getImpactInclusionGrah(query) {
    return this.networkService.get("api/impacts/inclusionReason/barGraph?"+query,null, null,'bearer');
  }

  
  
  getTypeAPI(query) {
    return this.networkService.get("api/impacts/type?"+query,null, null,'bearer');
  }

  getSourceAPI(query) {
    return this.networkService.get("api/impacts/source?"+query,null, null,'bearer');
  }
  saveImpactApi(body) {
    return this.networkService.post("api/impacts",body, null,'bearer');
  }
  updateImpactApi(body) {
    return this.networkService.put("api/impacts",body, null,'bearer');
  }
  deleteImpactApi(query) {
    return this.networkService.delete("api/impacts/"+query,null, null,'bearer');
  }
  deleteImpactSouceApi(query) {
    return this.networkService.delete("api/impacts/impactSources/"+query,null, null,'bearer');
  }
  deleteImpactTypeApi(query) {
    return this.networkService.delete("api/impacts/impactTypes/"+query,null, null,'bearer');
  }
  
  getImpactBarGraph(query) {
    return this.networkService.get("api/impacts/barGraph?"+query,null, null,'bearer');
  }
  getImpactPieGraph(query) {
    return this.networkService.get("api/impacts/pieChart?"+query,null, null,'bearer');
  }
  getUsersDropDownList (query:any) {
    return this.networkService.get("api/dashboard/users/list?"+query,null, null,'bearer');
  }
  

  getUserCirclesListApi(query) {
    return this.networkService.get("api/dashboard/circles?"+query,null, null,'bearer');
  }

}

